import { createApp } from 'vue';

if (document.getElementById('self-assessments-intros')) {
    const app = createApp({
    });
    
    app.mount('#self-assessments-intros');
}
